export class UserSimpleListReq {
  userName: string | undefined = undefined;
  realName: string | undefined = undefined;
  ids: string[] | undefined = undefined;
  limit: number | undefined = undefined;
	activatedStatus: number | undefined = undefined;
	onJob: boolean | undefined = undefined;
	status: number | undefined = undefined;
	staffType:string = 'no_type';
}

class UserSimpleRecord {
  id: number = 0;
  realName: string = "";
  userName: string = "";
  mobile: string = "";
}

export class UserSimpleListResp {
  records: UserSimpleRecord[] = [];
}
